import styled from "styled-components";

export const HeaderWithActionsStyled = styled.div`
  width: 100%;
  .theme_admin {
    display: flex;
    align-items: center;
    .box1 {
      width: 33.33%;
    }
    .box2 {
      width: 33.33%;
      display: flex;
      align-items: center;
      justify-content: center;
      .show_svg {
        display: flex;
        margin-right: 3px;
      }
      .group_label {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .top_title {
          font-size: ${({ theme }) => theme.FONT.SIZE.S24};
          font-family: ${({ theme }) => theme.FONT.STYLE.BOLD};
          color: ${({ theme }) => theme.COLORS.PURPLE_1};
          text-align: center;
        }
        .bottom_title {
          font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
          font-size: ${({ theme }) => theme.FONT.SIZE.S20};
          color: ${({ theme }) => theme.COLORS.PURPLE_1};
        }
      }
    }
    .btn_layer {
      width: 33.33%;
      justify-content: flex-end;
      display: flex;
    }
    .blank {
      width: 33.33%;
    }
  }
`;
